function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import React from 'react';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Flex } from '@finect/tabular-core/Flex';
import { Icon } from '../../Icon';
import { EntityCard } from '../../EntityCard';
import { getAuthorPath } from '../utils';
import { Image } from './../../Image';
import { Inner, AuthorBlock, AuthorName, OrganizationName, AuthorPartial } from './partials';
export var Author = function Author(_ref) {
  var author = _ref.author,
    _ref$basic = _ref.basic,
    basic = _ref$basic === void 0 ? false : _ref$basic,
    _ref$withIcon = _ref.withIcon,
    withIcon = _ref$withIcon === void 0 ? true : _ref$withIcon,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? -1 : _ref$iconSize,
    _ref$withOrganization = _ref.withOrganization,
    withOrganization = _ref$withOrganization === void 0 ? false : _ref$withOrganization,
    _ref$withOrganization2 = _ref.withOrganizationImage,
    withOrganizationImage = _ref$withOrganization2 === void 0 ? false : _ref$withOrganization2,
    _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? false : _ref$marginTop;
  var subtype = author.subtype,
    image = author.image,
    displayName = author.displayName,
    _author$organizations = author.organizations,
    organizations = _author$organizations === void 0 ? [] : _author$organizations;
  var authorPath = getAuthorPath(author);
  var imagePath = image || '';
  var authorHasProfile = author.hasProfile || author.subtype === 'user' && author.features && author.features.includes('profile');
  var authorNameProps = authorHasProfile ? {
    href: authorPath,
    as: 'a',
    title: "Ir al perfil de ".concat(displayName)
  } : {};
  var _organizations = _slicedToArray(organizations, 1),
    _organizations$ = _organizations[0],
    organization = _organizations$ === void 0 ? null : _organizations$;
  if (basic) {
    var Component = authorHasProfile ? AppLink : 'span';
    return React.createElement(AuthorPartial, null, React.createElement(Component, authorNameProps, React.createElement(Icon, {
      withBorder: true,
      size: 1,
      alt: author.displayName,
      image: imagePath,
      margin: "0 8px 0 0"
    }), React.createElement("div", null, author.displayName, withOrganization && organization ? React.createElement("span", {
      className: "author"
    }, organization.displayName) : null)));
  }
  var organizationPath = organization ? "/grupos/".concat(organization.alias) : '';
  return React.createElement(Inner, {
    marginTop: marginTop
  }, React.createElement(Flex, null, React.createElement(AuthorBlock, {
    withLink: true,
    withIcon: withIcon
  }, withIcon ? React.createElement(Icon, {
    size: iconSize,
    type: subtype,
    alt: displayName,
    image: imagePath,
    margin: "0 9px 0 0"
  }) : null, React.createElement("div", null, React.createElement("div", null, React.createElement("div", null, React.createElement(EntityCard, {
    type: "profile",
    entity: _objectSpread(_objectSpread({}, author), {}, {
      icon: imagePath,
      name: displayName
    })
  }, React.createElement(AuthorName, _extends({
    authorHasProfile: authorHasProfile,
    withOrganization: withOrganization,
    withOrganizationImage: withOrganizationImage
  }, authorNameProps), displayName))), withOrganization && organization ? React.createElement(EntityCard, {
    type: "profile",
    entity: _objectSpread(_objectSpread({}, organization), {}, {
      icon: organization.image,
      name: organization.displayName
    })
  }, React.createElement(OrganizationName, {
    title: authorNameProps.title,
    href: organizationPath,
    as: AppLink
  }, organization.displayName)) : null))), withOrganizationImage && organization && organization.image ? React.createElement(Image, {
    height: 24,
    format: "png",
    src: organization.image,
    alt: displayName
  }) : null));
};